// import React from "react";
// import { BrowserRouter as Router, Routes, Route,Navigate } from "react-router-dom";
// import Home from "./Home";
// import Survey from "./Survey";

// function App() {
//   return (
//     <Router>
//       <Routes >
//         <Route path="/" element={<Navigate to = '/survey' replace/>} />
//         <Route path="/survey" element={<Survey />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';

import ChangeManagement from './components/ChangeManagement/ChangeManagement';
import BusinessIntelligence from './components/BusinessIntelligence/BusinessIntelligence';
import SalesEffectiveness from './components/SalesEffectiveness/SalesEffectiveness';
import './App.css';
import Survey from './Survey';
import WhoWeAreSection from './components/WhoWeAreSection/WhoWeAreSection';
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import ContactForm from './components/ContactForm/ContactForm';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Home />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/survey" element={<Survey />} />
          <Route path="/services/change-management" element={<ChangeManagement />} />
          <Route path="/services/business-intelligence" element={<BusinessIntelligence />} />
          <Route path="/services/sales-effectiveness" element={<SalesEffectiveness />} />
          <Route path="/get-in-touch" element={<ContactForm />} />
          {/* Add a 404 route */}
          <Route path="*" element={<div>Page Not Found</div>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
